/* =========================

  FV

============================ */
import {break_point_pc_} from "../../Styled/mixin";
import {break_point_sp_} from "../../Styled/mixin";



/* -------------------------

  component

---------------------------- */
function ImageRetina( props ) {
  return (
    <>
      {
        (props.src_sp_1x)?
        <picture className="img">

          <source type={`image/${props.type}`} media={break_point_pc_} srcSet={`${process.env.PUBLIC_URL}${props.src_pc_1x} 1x, ${process.env.PUBLIC_URL}${props.src_pc_2x} 2x`} />

          <source type={`image/${props.type}`} media={break_point_sp_} srcSet={`${process.env.PUBLIC_URL}${props.src_sp_1x} 1x, ${process.env.PUBLIC_URL}${props.src_sp_2x} 2x`} />

          <img src={`${process.env.PUBLIC_URL}${props.src_pc_1x}`} alt={(props.alt)?props.alt:``} />

        </picture>
        :
        <p className="img"><img src={`${process.env.PUBLIC_URL}${props.src_pc_1x}`} srcSet={`${process.env.PUBLIC_URL}${props.src_pc_1x} 1x, ${process.env.PUBLIC_URL}${props.src_pc_2x} 2x`} alt={(props.alt)?props.alt:``}　/></p>
      }
    </>
  );
}

export default ImageRetina;
